'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _nuiIntl = require('@concur/nui-intl');

var _reactRedux = require('react-redux');

var _listingModule = require('./listingModule');

var actions = _interopRequireWildcard(_listingModule);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutoConnectInput = function AutoConnectInput(_ref) {
  var listing = _ref.listing,
      isDisabled = _ref.isDisabled,
      updateLoyaltyNum = _ref.updateLoyaltyNum,
      formatter = _ref.formatter;
  var loyaltyNumber = listing.loyaltyNumber,
      ID = listing.ID;


  var handleFormUpdate = function handleFormUpdate(e) {
    updateLoyaltyNum(ID, e.target.value);
    updateLoyaltyNum(listing.core.v1ID, e.target.value);
  };

  var htmlMarkup = function htmlMarkup(html) {
    return { __html: html };
  };

  var renderLoyaltyInput = function renderLoyaltyInput() {
    if (!listing.core.triplinkLoyaltyNumber) {
      return _react2.default.createElement(
        'div',
        { className: 'form-group' },
        _react2.default.createElement('input', {
          style: { width: '100%' },
          type: 'text', name: 'loyaltyNumber',
          className: 'form-control',
          disabled: isDisabled,
          'aria-label': formatter.formattedMessage({ id: 'LoyaltyNumber1', values: { number: '' } }),
          placeholder: formatter.formattedMessage({ id: 'LoyaltyNumber1', values: { number: '' } }),
          value: loyaltyNumber,
          onChange: handleFormUpdate
        })
      );
    }
    if (!listing.core.isConnectionPending) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('h4', { dangerouslySetInnerHTML: htmlMarkup(formatter.formattedMessage({ id: 'ExistingLoyaltyNum' })) })
      );
    }
  };

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h3',
      null,
      _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Connect' })
    ),
    _react2.default.createElement('br', null),
    !listing.core.triplinkLoyaltyNumber && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'h4',
        null,
        _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'AddLoyaltyNumber' })
      ),
      _react2.default.createElement('br', null)
    ),
    renderLoyaltyInput()
  );
};

AutoConnectInput.contextTypes = { nuiIntl: _propTypes2.default.object };

AutoConnectInput.propTypes = {
  listing: _propTypes2.default.shape({
    loyaltyNumber: _propTypes2.default.string
  }),
  updateLoyaltyNum: _propTypes2.default.func.isRequired,
  formatter: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(null, { updateLoyaltyNum: actions.updateLoyaltyNum })((0, _nuiIntl.withFormatter)(AutoConnectInput));


//////////////////
// WEBPACK FOOTER
// ./lib/listing/AutoConnectInput.js
// module id = 584
// module chunks = 0